import { NgModule } from '@angular/core';
import { AuthGuard, provideConfig } from '@spartacus/core';
import {
  DIALOG_TYPE,
  OutletPosition,
  ProductDetailOutlets,
  ProductListOutlets,
  provideOutlet,
} from '@spartacus/storefront';
import { CustomCheckoutPlaceOrderComponent } from './checkout/checkout-place-order/checkout-place-order.component';
import { CustomConfiguratorProductTitleComponent } from './configurator/product-title/configurator-product-title.component';
import { CustomRedirectComponent } from './landing-page-redirect/landing-page-redirect.component';
import { CustomOrderOverviewComponent } from './order/order-overview/order-overview/order-overview.component';
import { ProductAttachmentTabComponent } from './product/product-attachment-tab/product-attachment-tab.component';
import { CustomProductGridItemActionComponent } from './product/product-grid-item-actions/product-grid-item-actions.component';
import { CustomProductGridItemDetailComponent } from './product/product-grid-item-details/product-grid-item-details.component';
import { CustomProductImageZoomDialogComponent } from './product/product-image-zoom/product-image-zoom-dialog/product-image-zoom-dialog.component';
import { CustomProductImageZoomProductImagesComponent } from './product/product-image-zoom/product-image-zoom-product-images/product-image-zoom-product-images.component';
import { CustomProductSummaryComponent } from './product/product-summary/product-summary.component';
import { ProductTitleComponent } from './product/product-title/product-title.component';
import { CustomQuoteCommentsComponent } from './quotes/comments/quote-comments.component';
import { CustomScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { CustomTabParagraphContainerComponent } from './tab-paragraph-container/tab-paragraph-container.component';

@NgModule({
  providers: [
    provideOutlet({
      id: ProductListOutlets.ITEM_DETAILS,
      position: OutletPosition.REPLACE,
      component: CustomProductGridItemDetailComponent,
    }),
    provideOutlet({
      id: ProductListOutlets.ITEM_ACTIONS,
      position: OutletPosition.REPLACE,
      component: CustomProductGridItemActionComponent,
    }),
    provideOutlet({
      id: 'LandingPage2Template',
      position: OutletPosition.REPLACE,
      component: CustomRedirectComponent,
    }),
    provideOutlet({
      id: 'ProductDetailsPageTemplate',
      position: OutletPosition.BEFORE,
      component: ProductTitleComponent,
    }),
    provideOutlet({
      id: ProductDetailOutlets.SUMMARY,
      position: OutletPosition.REPLACE,
      component: CustomProductSummaryComponent,
    }),
    provideConfig({
      cmsComponents: {
        CMSProductListComponent: {
          component: () =>
            import('./product/product-list/product-list.component').then(
              (m) => m.CustomProductListComponent,
            ),
        },
        SearchResultsListComponent: {
          component: () =>
            import('./product/product-list/product-list.component').then(
              (m) => m.CustomProductListComponent,
            ),
        },
        BreadcrumbComponent: {
          component: () =>
            import('./breadcrumb/breadcrumb.component').then((m) => m.CustomBreadcrumbComponent),
        },
        ProductIntroComponent: {
          component: () =>
            import('./product/product-intro/product-intro.component').then(
              (m) => m.CustomProductIntroComponent,
            ),
        },
        CheckoutReviewOrder: {
          component: () =>
            import('./checkout/checkout-review-submit/checkout-review-submit.component').then(
              (m) => m.CustomCheckoutReviewSubmitComponent,
            ),
        },
        OpfCheckoutReview: {
          component: () =>
            import('./checkout/opf/opf-checkout-review-submit/checkout-review-submit.component').then(
              (m) => m.CustomOpfCheckoutReviewSubmitComponent,
            ),
        },
        CheckoutProgress: {
          component: () =>
            import('./checkout/checkout-progress/checkout-progress.component').then(
              (m) => m.CustomCheckoutProgressComponent,
            ),
        },
        OrderConfirmationThankMessageComponent: {
          component: () =>
            import('./order/order-confirmation-thank-you-message/order-confirmation-thank-you-message.component').then(
              (m) => m.CustomOrderConfirmationThankYouMessageComponent,
            ),
        },
        OrderConfirmationOverviewComponent: {
          component: () =>
            import('./order/order-overview/order-overview/order-overview.component').then(
              (m) => m.CustomOrderOverviewComponent,
            ),
        },
        ReturningCustomerLoginComponent: {
          component: () =>
            import('./login/login-form.component').then((m) => m.CustomLoginFormComponent),
        },
        ProductFilesTabComponent: {
          component: ProductAttachmentTabComponent,
        },
        deliveryTab: {
          component: ProductAttachmentTabComponent,
        },
        ScrollToTopComponent: {
          component: CustomScrollToTopComponent,
        },
        ProductImagesComponent: {
          component: CustomProductImageZoomProductImagesComponent,
        },
        ConfiguratorProductTitle: {
          component: CustomConfiguratorProductTitleComponent,
        },
        AccountOrderDetailsOverviewComponent: {
          component: CustomOrderOverviewComponent,
        },
        CMSTabParagraphContainer: {
          // Lazy loading is not working
          component: CustomTabParagraphContainerComponent,
        },
        CheckoutPlaceOrder: {
          component: CustomCheckoutPlaceOrderComponent,
        },
        // CartProceedToCheckoutComponent: {
        //   component: CustomCartProceedToCheckoutComponent,
        // },
        QuoteCommentsComponent: {
          component: CustomQuoteCommentsComponent,
          guards: [AuthGuard],
        },
      },
      launch: {
        PRODUCT_IMAGE_ZOOM: {
          inline: true,
          component: CustomProductImageZoomDialogComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class CustomComponentsModule {}
